import { useState } from "react";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useAttributes } from "@mibuildweb/hooks";

export const useCategoryDetailTabViewModel = () => {
  const [attributeOptions, setAttributeOptions] = useState([]);

  const { getAttributes } = useAttributes();

  const fetchAttributeOptions = async () => {
    const response = await getAttributes();
    if (response.status === HTTP_STATUSES.OK) {
      const options = response.data.map((attribute) => ({
        id: attribute.id,
        name: attribute.name,
      }));
      setAttributeOptions(options);
    }
  };

  return {
    fetchAttributeOptions,
    attributeOptions,
  };
};
